'use client';

import isPropValid from '@emotion/is-prop-valid';
import { useServerInsertedHTML } from 'next/navigation';
import { type PropsWithChildren, useState } from 'react';
import { ServerStyleSheet, StyleSheetManager } from 'styled-components';

interface Props extends PropsWithChildren {
  isPrerender?: boolean;
}

export default function StyledComponentsRegistry({
  children,
  isPrerender,
}: Props) {
  const [styledComponentsStyleSheet] = useState(() => new ServerStyleSheet());

  useServerInsertedHTML(() => {
    const styles = styledComponentsStyleSheet.getStyleElement();
    styledComponentsStyleSheet.instance.clearTag();

    return <>{styles}</>;
  });

  const sheet =
    typeof window === 'undefined'
      ? styledComponentsStyleSheet.instance
      : undefined;

  return (
    <StyleSheetManager
      disableCSSOMInjection={isPrerender}
      // Disable CSSOM injection in prerender context so styles are serialized as
      // text into <style> tags and appear in the HTML snapshot taken by Prerender.io.
      // By default styled-components uses insertRule() (CSSOM) which is fast but
      // not captured in document.documentElement.outerHTML.
      enableVendorPrefixes
      sheet={sheet}
      shouldForwardProp={(propName) => isPropValid(propName)}
    >
      {children}
    </StyleSheetManager>
  );
}
